import { render, staticRenderFns } from "./ConsumerTable.vue?vue&type=template&id=36f25d75&scoped=true"
import script from "./ConsumerTable.vue?vue&type=script&lang=js"
export * from "./ConsumerTable.vue?vue&type=script&lang=js"
import style0 from "./ConsumerTable.vue?vue&type=style&index=0&id=36f25d75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f25d75",
  null
  
)

export default component.exports